import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button, Dropdown, Image } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { Search, Menu, X, User, Settings, LogOut, Shield } from 'lucide-react';

const AppNavbar = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Navbar expand="lg" className="border-bottom shadow-sm">
      <Container fluid>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/" className="fw-bold text-primary">
          <i className="fas fa-brain me-2"></i>
          PromptHub
        </Navbar.Brand>

        {/* Mobile Menu Button */}
        <Button
          variant="outline-secondary"
          size="sm"
          className="d-lg-none"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </Button>

        {/* Navigation Links */}
        <Navbar.Collapse id="navbar-nav" className={isMenuOpen ? 'show' : ''}>
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" className="nav-link">
              Home
            </Nav.Link>
            
            {isAuthenticated && (
              <>
                <Nav.Link as={Link} to="/dashboard" className="nav-link">
                  Dashboard
                </Nav.Link>
                <Nav.Link as={Link} to="/prompts" className="nav-link">
                  Prompts
                </Nav.Link>
                <Nav.Link as={Link} to="/tags" className="nav-link">
                  Tags
                </Nav.Link>
                {isAdmin && (
                  <Nav.Link as={Link} to="/admin" className="nav-link">
                    Admin
                  </Nav.Link>
                )}
              </>
            )}
          </Nav>

          {/* User Menu */}
          <Nav className="ms-auto">
            {isAuthenticated ? (
              <Dropdown align="end">
                <Dropdown.Toggle variant="link" className="text-decoration-none">
                  <div className="d-flex align-items-center">
                    {user?.avatar ? (
                      <Image
                        src={user.avatar}
                        alt={user.name}
                        roundedCircle
                        width={32}
                        height={32}
                        className="me-2"
                      />
                    ) : (
                      <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                           style={{ width: '32px', height: '32px' }}>
                        {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                      </div>
                    )}
                    <span className="d-none d-md-block">{user?.name}</span>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Header>
                    <div className="fw-bold">{user?.name}</div>
                    <div className="text-muted small">{user?.email}</div>
                    <div className="text-muted small">
                      Role: <span className="text-capitalize">{user?.role}</span>
                    </div>
                  </Dropdown.Header>
                  
                  <Dropdown.Divider />
                  
                  <Dropdown.Item as={Link} to="/profile">
                    <User size={16} className="me-2" />
                    Profil
                  </Dropdown.Item>
                  
                  <Dropdown.Item as={Link} to="/profile">
                    <Settings size={16} className="me-2" />
                    Einstellungen
                  </Dropdown.Item>
                  
                  {isAdmin && (
                    <Dropdown.Item as={Link} to="/admin">
                      <Shield size={16} className="me-2" />
                      Admin-Panel
                    </Dropdown.Item>
                  )}
                  
                  <Dropdown.Divider />
                  
                  <Dropdown.Item onClick={handleLogout} className="text-danger">
                    <LogOut size={16} className="me-2" />
                    Abmelden
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button as={Link} to="/login" variant="primary" size="sm">
                <i className="fab fa-google me-2"></i>
                Mit Google anmelden
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
